import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import * as skyrimStakeActions from '../../../../../../../actions/skyrim-stake-actions';
import { formatToken } from '../../../../../../../helpers/token-helper';
import SkyrimIcon from '../../../../../../../assets/images/Skyrim.svg';
import Details from '../../../../../../../components/Stake/frame/details';

const StakeDetails = () => {
  const dispatch = useDispatch();
  const { amount } = useSelector((state) => state.SKYRIMstake.stake);
  const stakingToken = `${formatToken(amount)} SKYRIM`;
  const descriptions = [
    `Staking will start immediately after clicking "Stake Now" but Staking Rewards will not be generated until 24 hours after.`,
    `You may unstake your tokens at any time. There is an 8 days unstaking period you must wait before withdrawing your staked tokens.`,
  ];
  return (
    <>
      <Header
        icon={SkyrimIcon}
        title={'SKYRIM-Staking'}
        onClickBack={() => dispatch(skyrimStakeActions.stakeSettings())}
      />
      <Details
        title={'You Are Staking:'}
        token={stakingToken}
        buttonClick={() => dispatch(skyrimStakeActions.stakeSend({ amount }))}
        descriptions={descriptions}
        textButton={'Stake Now'}
      />
    </>
  );
};

export default StakeDetails;
